module.exports = __webpack_public_path__ + "static/media/logo.2a37a820.png";